import React, { useEffect, useRef } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PrivateRoute from "./authentication/PrivateRoute";
import LoginPage from "./authentication/LoginPage";
import { isAuthenticated } from "./api/authenticationApi";
import * as PG from "./pages";
import { InvestigationPage } from "./pages/InvestigationPage";
import "./App.css";
window.fetchTest = async () => {
    try {
        const response = await fetch("http://127.0.0.1:7000/token/obtain", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ answer: 42 }),
        });
        console.log("fetchTest done");
        return response;
    } catch (error) {
        console.log(typeof error);
        console.log(error);
        console.log(error.message);
    }
};

function App({ accessToken }) {
    if (!accessToken) {
        accessToken = localStorage.getItem("access_token");
    }
    // debugger;
    var is_admin = false;
    var tokenParts = null;
    var user_name = "";
    if (accessToken) {
        tokenParts = JSON.parse(atob(accessToken.split(".")[1]));
        is_admin = tokenParts.is_staff || tokenParts.is_superuser;
    }

    return (
        <>
            <div id="loading-animation" className="no-loading"></div>
            <Switch>
                {is_admin && (
                    <PrivateRoute
                        exact
                        path="/dashboard"
                        component={PG.DashboardPage}
                    />
                )}
                <PrivateRoute
                    exact
                    path="/monitoring-pc"
                    component={PG.MonitoringPCPage}
                />
                <PrivateRoute
                    exact
                    path="/investigatescreen"
                    component={() => <InvestigationPage alg_type="screen" />}
                    alg_type="ns"
                />
                <PrivateRoute
                    exact
                    path="/investigateprint"
                    component={() => <InvestigationPage alg_type="print" />}
                    alg_type="ns"
                />
                {!isAuthenticated() ? (
                    <>
                        <Route path="/" component={LoginPage} />
                    </>
                ) : (
                    <>
                        {is_admin ? (
                            <Route path="/" component={PG.DashboardPage} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: "/investigatescreen",
                                }}
                            />
                        )}
                    </>
                )}
            </Switch>
        </>
    );
}

export default App;
